import styled from 'styled-components'
import { useHistory, useLocation } from 'react-router'
import { Button } from 'react-bootstrap'

const Pagination = ({ page = 1, paramname = 'page' }) => {
  const history = useHistory()
  const location = useLocation()

  const onPrev = () => {
    if (page > 1) {
      history.replace({ pathname: location.pathname, search: `${paramname}=${page - 1}` })
    }
  }

  const onNext = () => {
    history.replace({ pathname: location.pathname, search: `${[paramname]}=${page + 1}` })
  }

  return (
    <Container>
      <Button onClick={onPrev}>{`<`}</Button>
      <Button>{page}</Button>
      <Button onClick={onNext}>{`>`}</Button>
    </Container>
  )
}

export default Pagination

const Container = styled.div`
  display: flex;
  justify-content: center;
  margin: 10px 0;
`
